import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dental-first-features',
  templateUrl: './dental-first-features.component.html',
  styleUrls: ['./dental-first-features.component.css']
})
export class DentalFirstFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
